import Axios from "axios-observable";
import { AuthService } from "@/services/auth.service";
import { AuthError } from "@azure/msal-browser";
import config from "@/client/config";

window.axiosEpdpApi = Axios.create({
  baseURL: `${config.epdpApiUrl}/api`,
  withCredentials: true,
});

window.axiosEpdpApi.interceptors.request.use(async (config: any) => {
  if (config.withCredentials && config.withCredentials === true) {
    const res = await AuthService.acquireTokenEpdpApi();
    if (res) {
      config.headers.Authorization = `Bearer ${res.accessToken}`;
    }
    if (res instanceof AuthError) {
      return Promise.reject(res);
    }
  }
  return config;
});
